import type { Route } from "./+types/home";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router";

import screenshot1 from "../assets/1.png";
import screenshot2 from "../assets/2.png";
import screenshot3 from "../assets/3.png";
import logo from "../assets/logo.png";
import icon from "../assets/logo.ico";

export function meta({}: Route.MetaArgs) {
  return [
    { 
      title: "أديم المناسبات - احجز خدماتك بسهولة | منصة خدمات المناسبات الأولى في السعودية" 
    },
    {
      name: "description",
      content: "احجز جميع خدمات المناسبات في السعودية من مكان واحد مع أديم - ضيافة، تصوير، تنسيق حفلات، مكياج، سامري وعرضة. خدمات موثوقة وأسعار تنافسية مع ضمان الجودة.",
    },
    {
      name: "keywords",
      content: "أديم، مناسبات، حفلات، ضيافة، تصوير، مكياج، تنسيق حفلات، سامري، عرضة سعودية، كيترنق، هير ستايل، السعودية، الرياض، جدة، الدمام، حجز خدمات، تطبيق مناسبات، خدمات زفاف، خدمات مواليد",
    },
    {
      name: "author",
      content: "أديم المناسبات",
    },
    {
      name: "robots",
      content: "index, follow",
    },
    {
      name: "language",
      content: "Arabic",
    },
    {
      name: "geo.region",
      content: "SA",
    },
    {
      name: "geo.country",
      content: "Saudi Arabia",
    },
    {
      name: "geo.placename",
      content: "المملكة العربية السعودية",
    },
    {
      name: "apple-mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "apple-mobile-web-app-status-bar-style",
      content: "black-translucent",
    },
    {
      name: "apple-mobile-web-app-title",
      content: "أديم المناسبات",
    },
    {
      name: "mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "theme-color",
      content: "#58654C",
    },
    {
      name: "msapplication-TileColor",
      content: "#58654C",
    },
    // Open Graph Meta Tags
    { 
      property: "og:title", 
      content: "أديم المناسبات - احجز خدماتك بسهولة | منصة خدمات المناسبات الأولى في السعودية" 
    },
    {
      property: "og:description",
      content: "احجز جميع خدمات المناسبات في السعودية من مكان واحد مع أديم - ضيافة، تصوير، تنسيق حفلات، مكياج، سامري وعرضة. خدمات موثوقة وأسعار تنافسية.",
    },
    {
      property: "og:image",
      content: logo,
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "630",
    },
    {
      property: "og:image:alt",
      content: "أديم المناسبات - منصة خدمات المناسبات في السعودية",
    },
    {
      property: "og:url",
      content: "https://adim-app.com",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:site_name",
      content: "أديم المناسبات",
    },
    {
      property: "og:locale",
      content: "ar_SA",
    },
    // Twitter Card Meta Tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: "أديم المناسبات - احجز خدماتك بسهولة | منصة خدمات المناسبات الأولى في السعودية",
    },
    {
      name: "twitter:description",
      content: "احجز جميع خدمات المناسبات في السعودية من مكان واحد مع أديم - ضيافة، تصوير، تنسيق حفلات، مكياج، سامري وعرضة.",
    },
    {
      name: "twitter:image",
      content: logo,
    },
    {
      name: "twitter:image:alt",
      content: "أديم المناسبات - منصة خدمات المناسبات في السعودية",
    },
    // App Store Meta Tags
    {
      name: "apple-itunes-app",
      content: "app-id=app-id=6758246638",
    },
    {
      name: "google-play-app",
      content: "app-id=com.adim.events",
    },
    // Canonical URL
    {
      tagName: "link",
      rel: "canonical",
      href: "https://adim-app.com",
    },
    // Favicon
    {
      tagName: "link",
      rel: "icon",
      type: "image/x-icon",
      href: icon,
    },
    {
      tagName: "link",
      rel: "apple-touch-icon",
      href: logo,
    },
    // Structured Data JSON-LD
    {
      tagName: "script",
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "أديم المناسبات",
        "alternateName": "Adim Events",
        "url": "https://adim-app.com",
        "logo": logo,
        "description": "منصتك الأولى لحجز جميع خدمات المناسبات في المملكة العربية السعودية",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "الرياض",
          "addressCountry": "SA",
          "addressRegion": "المنطقة الوسطى"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+966-55-7076035",
          "contactType": "customer service",
          "email": "info@adim-app.com",
          "availableLanguage": "Arabic"
        },
        "sameAs": [
          "https://apps.apple.com/sa/app/%D8%A7%D8%AF%D9%8A%D9%85-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%B3%D8%A8%D8%A7%D8%AA/id6758246638",
          "https://play.google.com/store/apps/details?id=com.adim.events"
        ],
        "areaServed": "SA",
        "serviceType": [
          "ضيافة نساء ورجال",
          "مصورين ومصورات",
          "سامري و عرضة سعودية",
          "تنسيق طاولات وضيافة",
          "تنسيق حفلات و استقبال ومواليد",
          "هير ستايل",
          "ميك أب آرتست",
          "كيترنق"
        ]
      })
    },
    // App Schema
    {
      tagName: "script",
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "MobileApplication",
        "name": "أديم المناسبات",
        "operatingSystem": ["iOS", "Android"],
        "applicationCategory": "BusinessApplication",
        "downloadUrl": [
          "https://apps.apple.com/app/adim-events",
          "https://play.google.com/store/apps/details?id=com.adim.events"
        ],
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "SAR"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "1000"
        }
      })
    }
  ];
}

const services = [
  {
    id: 1,
    name: "ضيافة نساء ورجال",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/2dh8sKMDJu6kCLPDTju5ah6lVCQBuZlECoVrk9UJ.svg",
  },
  {
    id: 2,
    name: "مصورين ومصورات",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/Xq2cIOGwAmL1BXoqGvh7elHsLSfT9a5zvlNl4xuj.svg",
  },
  {
    id: 3,
    name: "سامري و عرضة سعودية",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/aLYIkdXQIfeqmdleRdoomGSyuTULxCJfS54rgoir.svg",
  },
  {
    id: 4,
    name: "تنسيق طاولات وضيافة",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/WkRmgrkL4KdXx2kA0R2Anvi0KrAMDTPR3NHoqPQC.svg",
  },
  {
    id: 5,
    name: "تنسيق حفلات و استقبال ومواليد",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/aA2bhPWNbXxJM6O4NL6ZGiCCoiFTrkbxR9mMZAcT.svg",
  },
  {
    id: 6,
    name: "هير ستايل",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/K1qpgK91BeRrMuj5zThB8VrAH8cTC0Nu3ZZaZHIW.svg",
  },
  {
    id: 7,
    name: "ميك أب آرتست",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/7FwasJl7SonUxdsaWJLt1JFXp8Qyt0Ja5UbEpqEj.svg",
  },
  {
    id: 8,
    name: "كيترنق",
    icon: "https://admin-staging.adim-app.com/storage/services-icons/maFrJcoetwhrU0vocJXp9ebRc3kKyXSZwgQy8OON.svg",
  },
];

const features = [
  {
    icon: "⚡",
    title: "سريع وسهل",
    description: "احجز خدماتك في دقائق معدودة بخطوات بسيطة",
  },
  {
    icon: "✨",
    title: "جودة عالية",
    description: "مقدمي خدمات محترفين ومعتمدين",
  },
  {
    icon: "💰",
    title: "أسعار تنافسية",
    description: "أفضل الأسعار مع ضمان الجودة",
  },
  {
    icon: "🛡️",
    title: "ضمان الخدمة",
    description: "حقوقك محفوظة ومضمونة معنا",
  },
];

export default function Home() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [featuresIndex, setFeaturesIndex] = useState(0);

  const screenshots = [screenshot1, screenshot2, screenshot3];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setIndex((i) => (i + 1) % screenshots.length),
      3500
    );
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(
      () => setFeaturesIndex((i) => (i + 1) % features.length),
      4000
    );
    return () => clearInterval(t);
  }, []);

  // Add/remove body class when menu opens/closes
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isMenuOpen]);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#58654C]">
      {/* Skip to main content for accessibility */}
      <a 
        href="#main" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-blue-600 text-white px-3 py-2 rounded"
      >
        تخطي إلى المحتوى الرئيسي
      </a>

      {/* Header / Nav */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-[#58654C] backdrop-blur-md border-b-2 border-[#BFA15D] shadow-xl md:mx-[6em] mx-[1em] mt-[.5em] rounded-[5em]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center justify-between h-16 lg:h-20" role="navigation" aria-label="القائمة الرئيسية">
            {/* Logo */}
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <img
                src={logo}
                alt="شعار أديم المناسبات"
                className="h-10 lg:h-12 brightness-0 invert"
                height="48"
              />
            </div>

            {/* Desktop Navigation */}
            <ul className="hidden md:flex items-center rtl:space-x-reverse gap-[2em]" role="menubar">
              <li role="menuitem">
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-[#fff] transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم الرئيسية"
                >
                  الرئيسية
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => scrollToSection("services")}
                  className="text-[#fff] transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم خدماتنا"
                >
                  خدماتنا
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => scrollToSection("features")}
                  className="text-[#fff] transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم لماذا أديم"
                >
                  لماذا أديم
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => scrollToSection("screenshots")}
                  className="text-[#fff] transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم شاشات التطبيق"
                >
                  شاشات التطبيق
                </button>
              </li>
               <li role="menuitem">
                <Link
                  to="/terms"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم شروط وأحكام الاستخدام"
                >
                  شروط وأحكام الاستخدام  
                </Link>
              </li>
              <li role="menuitem">
                <Link
                  to="/privacy"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="سياسة الخصوصية"
                >
                  سياسة الخصوصية
                </Link>
              </li>
            </ul>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 transform"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
              aria-label={isMenuOpen ? "إغلاق القائمة" : "فتح القائمة"}
            >
              <svg
                className={`w-6 h-6 transition-transform duration-300 ${isMenuOpen ? "rotate-90 scale-90" : "rotate-0 scale-100"}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </nav>
        </div>
      </header>

      {/* Full Screen Mobile Menu Popup - Outside Header */}
      {isMenuOpen && (
        <div
          className="mobile-menu-overlay md:hidden fixed inset-0 bg-[#58654C] transition-all duration-500 ease-in-out opacity-100 visible animate-fadeIn"
          style={{
            zIndex: "999999 !important",
            backgroundColor: "#58654C",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            margin: 0,
            padding: 0,
            animation: "fadeInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* Menu Content */}
          <div className="relative h-full flex flex-col animate-slideInUp">
            {/* Header with Close Button */}
            <div
              className="flex items-center justify-between p-6 border-b border-white/20 animate-slideInDown"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="flex items-center gap-3">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-8 brightness-0 invert animate-bounceIn"
                  style={{ animationDelay: "0.3s" }}
                />
              </div>

              <button
                onClick={() => setIsMenuOpen(false)}
                className="p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 hover:rotate-90 animate-fadeInRight"
                style={{ animationDelay: "0.2s" }}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Navigation Links */}
            <div
              className="flex-1 flex flex-col justify-start items-start px-1 text-right animate-fadeInUp mt-8"
              style={{ animationDelay: "0.4s" }}
            >
              <button
                onClick={() => {
                  scrollToSection("home");
                  setIsMenuOpen(false);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                الرئيسية
              </button>
              <button
                onClick={() => {
                  scrollToSection("services");
                  setIsMenuOpen(false);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                خدماتنا
              </button>
              <button
                onClick={() => {
                  scrollToSection("features");
                  setIsMenuOpen(false);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.6s" }}
              >
                لماذا أديم
              </button>
              <button
                onClick={() => {
                  scrollToSection("screenshots");
                  setIsMenuOpen(false);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.7s" }}
              >
                شاشات التطبيق
              </button>
              <Link
                to="/terms"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.8s" }}
              >
                شروط وأحكام الاستخدام
              </Link>
              <Link
                to="/privacy"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.9s" }}
              >
                سياسة الخصوصية
              </Link>
            </div>

            {/* Screenshot Display - Bottom Half */}
            <div
              className="relative h-100 overflow-hidden animate-fadeInUp rounded flex justify-center "
              style={{ animationDelay: "0.9s" }}
            >
              <img
                src={screenshots[0]}
                alt="شاشة التطبيق"
                className="absolute bottom-[-7em] w-auto h-full  object-top rounded"
              />
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <main id="main" role="main">
        <section id="home" className="pt-24 lg:pt-32 pb-16 lg:pb-24" aria-labelledby="hero-heading">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              {/* Left - Content */}
              <article className="text-center lg:text-right space-y-8">
                {/* Badge */}
                <div className="inline-flex items-center pt-4 py-2 rounded-full">
                  <span className="text-[#BFA15D] font-bold text-sm lg:text-base">
                    منصة خدمات المناسبات الأولى في المملكة
                  </span>
                </div>

                {/* Main Heading */}
                <h1 
                  id="hero-heading"
                  className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-[#58654C] leading-tight font-bold"
                >
                  اجعل{" "}
                  <span className="text-[--color-primary] relative">
                    مناسبتك
                    <div className="absolute -bottom-2 right-0 w-full h-1 bg-[--color-primary]/20 rounded-full"></div>
                  </span>
                  <br />
                  <span className="text-[--color-secondary]">استثنائية</span>
                </h1>

                {/* Description */}
                <p className="text-md lg:text-md text-gray-600 leading-relaxed">
                  احجز جميع خدمات مناسبتك من مكان واحد: ضيافة، تصوير، تنسيق حفلات،
                  مكياج وتسريحات، وأكثر من ذلك. تجربة سريعة وموثوقة.
                </p>

                {/* App Store Badges */}
                <div className="flex flex-col sm:flex-row gap-4 items-center justify-center lg:justify-start" role="group" aria-label="روابط تحميل التطبيق">
                  <a
                    href="https://apps.apple.com/sa/app/%D8%A7%D8%AF%D9%8A%D9%85-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%B3%D8%A8%D8%A7%D8%AA/id6758246638"
                    className="inline-flex items-center min-w-[15em] py-4 justify-center bg-black text-white rounded-2xl hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
                    aria-label="تحميل أديم المناسبات من App Store"
                  >
                  <svg
                    className="w-8 h-8 ml-3"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M16.365 1.43c-.886.045-1.91.592-2.51 1.284-.54.62-1.02 1.705-.845 2.705.966.04 1.97-.523 2.56-1.233.55-.66 1.01-1.71.795-2.756zM12.76 4.47c-.94 0-2.16.64-2.85.64-.72 0-1.9-.63-3.12-.63-1.71 0-3.7 1.03-4.69 2.9-2.01 3.7-.51 9.2 1.44 12.2.98 1.55 2.14 3.28 3.67 3.22 1.48-.05 2.04-.96 3.82-.96 1.78 0 2.32.96 3.82.93 1.62-.03 2.66-1.57 3.63-3.12 1.15-1.83 1.63-3.6 1.65-3.69-.04-.02-3.17-1.22-3.2-4.85-.03-3.97 3.23-5.28 3.33-5.35-.02-.09-1.47-1.97-4.03-1.97-1.57 0-2.78.98-3.51.98-.69 0-1.84-1-3.05-1z" />
                  </svg>
                  <div>
                    <div className="text-xs">حمّل من</div>
                    <div className="text-lg font-semibold">App Store</div>
                  </div>
                </a>

                <a
                  href="#"
                  className="inline-flex items-center min-w-[15em] py-4 justify-center  bg-black text-white rounded-2xl hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-8 h-8 ml-3"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                  </svg>
                  <div>
                    <div className="text-xs">حمّل من</div>
                    <div className="text-lg font-semibold">Google Play</div>
                  </div>
                </a>
              </div>
              </article>

            {/* Right - Phone Mockup */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                {/* Phone Frame */}
                <div className="relative">
                  <div className="w-45 h-96 lg:w-70 lg:h-[600px]  rounded-[2em] shadow-xl">
                    <div className="w-full h-full bg-[#FAFAFA] p-1 rounded-[2em] overflow-hidden shadow-inner">
                      <img
                        src={screenshots[index]}
                        alt={`شاشة ${index + 1}`}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>

                  {/* Floating Elements */}
                  <div className="absolute -top-4 -right-4 w-16 h-16 bg-[--color-secondary] rounded-full opacity-20 animate-pulse"></div>
                  <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-[--color-primary] rounded-full opacity-30 animate-bounce"></div>
                </div>

                {/* Screenshot Controls */}
                {/* <div className="flex justify-center gap-3 mt-6">
                  {screenshots.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setIndex(i)}
                      className={`w-3 h-3 rounded-full transition-all duration-200 ${
                        i === index
                          ? "bg-[--color-primary] scale-125"
                          : "bg-gray-300 hover:bg-gray-400"
                      }`}
                      aria-label={`شاشة ${i + 1}`}
                    />
                  ))}
                </div> */}
              </div>
            </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="py-20 lg:py-32 bg-white" aria-labelledby="services-heading">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <header className="text-center mb-16 lg:mb-24">
            <h2 id="services-heading" className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#58654c] mb-6">
              خدماتنا المميزة
            </h2>
            <p className="text-md lg:text-md text-gray-600 max-w-3xl mx-auto leading-relaxed">
              اختر من بين مجموعة واسعة من الخدمات الموثوقة والمختارة بعناية لجعل
              مناسبتك لا تُنسى
            </p>
          </header>

          {/* Services Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8" role="list" aria-label="قائمة الخدمات المتاحة">
            {services.map((service) => (
              <article
                key={service.id}
                className="group p-6 lg:p-8 bg-white border-2 border-gray-100 rounded-3xl hover:border-[--color-primary] hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
                role="listitem"
              >
                <header className="flex items-center justify-center mb-6">
                  <div className="relative w-16 h-16 lg:w-20 lg:h-20 rounded-2xl bg-[--color-primary]/10 group-hover:bg-[--color-primary] transition-all duration-300 flex items-center justify-center group-hover:scale-110">
                    <img
                      src={service.icon}
                      alt={`أيقونة خدمة ${service.name}`}
                      className="w-16 h-16 lg:w-20 lg:h-20 transition-all duration-300"
                      width="80"
                      height="80"
                      loading="lazy"
                    />
                  </div>
                </header>
                <h3 className="text-center font-medium text-gray-900 group-hover:text-[--color-primary] transition-colors duration-300 text-sm lg:text-base">
                  {service.name}
                </h3>
              </article>
            ))}
          </div>
        </div>
      </section>

        {/* Features Section */}
        <section
          id="features"
          className="py-20 lg:py-32 bg-gradient-to-b from-gray-50 to-white"
        >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16 lg:mb-24">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#58654c] mb-6">
              لماذا أديم؟
            </h2>
            <p className="text-md lg:text-md text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نسعى لتقديم أفضل تجربة حجز خدمات المناسبات مع ضمان الجودة والراحة
            </p>
          </div>

          {/* Features Grid - All Devices */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group p-6 sm:p-8 lg:p-10 bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center hover:-translate-y-2"
              >
                <div className="text-3xl sm:text-4xl lg:text-5xl mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                  {feature.icon}
                </div>
                <h3 className="text-md sm:text-md lg:text-md font-bold text-gray-900 mb-3 sm:mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm sm:text-sm lg:text-base">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 lg:py-32 bg-gradient-to-br from-[--color-primary] via-[--color-primary-dark] to-[--color-secondary]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative bg-white/10 backdrop-blur-sm rounded-3xl lg:rounded-[3rem] p-8 lg:p-16 text-center overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute bottom-0 right-0 w-48 h-48 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
            </div>

            <div className="relative z-10">
              <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                جاهز لتخطيط مناسبتك القادمة؟
              </h2>
              <p className="text-md lg:text-md text-white/90 max-w-3xl mx-auto mb-12 leading-relaxed">
                حمّل تطبيق أديم الآن واستمتع بتجربة حجز سلسة وسهلة مع أفضل مقدمي
                الخدمات
              </p>

              {/* Download Buttons */}
              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
                <a
                  href="https://apps.apple.com/sa/app/%D8%A7%D8%AF%D9%8A%D9%85-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%B3%D8%A8%D8%A7%D8%AA/id6758246638"
                  className="inline-flex items-center min-w-[15em] py-4 justify-center  bg-black text-white rounded-2xl hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-10 h-10 ml-4"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M16.365 1.43c-.886.045-1.91.592-2.51 1.284-.54.62-1.02 1.705-.845 2.705.966.04 1.97-.523 2.56-1.233.55-.66 1.01-1.71.795-2.756zM12.76 4.47c-.94 0-2.16.64-2.85.64-.72 0-1.9-.63-3.12-.63-1.71 0-3.7 1.03-4.69 2.9-2.01 3.7-.51 9.2 1.44 12.2.98 1.55 2.14 3.28 3.67 3.22 1.48-.05 2.04-.96 3.82-.96 1.78 0 2.32.96 3.82.93 1.62-.03 2.66-1.57 3.63-3.12 1.15-1.83 1.63-3.6 1.65-3.69-.04-.02-3.17-1.22-3.2-4.85-.03-3.97 3.23-5.28 3.33-5.35-.02-.09-1.47-1.97-4.03-1.97-1.57 0-2.78.98-3.51.98-.69 0-1.84-1-3.05-1z" />
                  </svg>
                  <div className="text-right">
                    <div className="text-sm opacity-70 ">حمّل من</div>
                    <div className="text-xl font-bold">App Store</div>
                  </div>
                </a>

                <a
                  href="#"
                  className="inline-flex items-center min-w-[15em] py-4 justify-center  bg-black text-white rounded-2xl hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-10 h-10 ml-4"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                  </svg>
                  <div className="text-right">
                    <div className="text-sm opacity-70">حمّل من</div>
                    <div className="text-xl font-bold">Google Play</div>
                  </div>
                </a>
              </div>

              {/* Trust Indicators */}
              <div className="flex flex-wrap gap-8 justify-center text-white/90">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <span>تقييم 4.9 نجوم</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>آمن ومضمون</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>دعم 24/7</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
        
        {/* Screenshots Gallery */}
        <section id="screenshots" className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16 lg:mb-24">
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#58654c] mb-6">
              شاشات التطبيق
            </h2>
            <p className="text-md lg:text-md text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نظرة سريعة على تجربة المستخدم الاستثنائية داخل تطبيق أديم
            </p>
          </div>

          {/* Screenshots Grid - Desktop */}
          <div className="hidden md:grid md:grid-cols-3 gap-8 lg:gap-12">
            {screenshots.map((screenshot, i) => (
              <div
                key={i}
                className="group relative mx-auto max-w-xs "
                onClick={() => setIndex(i)}
              >
                <div className="relative overflow-hidden rounded-3xl shadow-2xl ">
                  <img
                    src={screenshot}
                    alt={`شاشة ${i + 1}`}
                    className="w-full h-auto object-cover "
                  />
                </div>
                
                {/* Active Indicator */}
                {i === index && (
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[--color-secondary] rounded-full animate-pulse shadow-lg">
                    <div className="absolute inset-1 bg-white rounded-full"></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Screenshots Carousel - Mobile */}
          <div className="md:hidden relative max-w-xs mx-auto">
            {/* Main Screenshot Display */}
            <div className="relative overflow-hidden rounded-3xl shadow-2xl bg-gradient-to-br from-[--color-primary]/5 to-[--color-secondary]/5 p-4">
              <img
                src={screenshots[index]}
                alt={`شاشة ${index + 1}`}
                className="w-full h-auto object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Screenshot Thumbnails */}
            <div className="flex justify-center gap-3 mt-6">
              {screenshots.map((screenshot, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`relative w-16 h-20 rounded-xl overflow-hidden border-2 transition-all duration-300 ${
                    i === index
                      ? "border-[--color-primary] scale-110 shadow-lg"
                      : "border-gray-300 hover:border-[--color-secondary] opacity-70 hover:opacity-100"
                  }`}
                >
                  <img
                    src={screenshot}
                    alt={`شاشة ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                  {i === index && (
                    <div className="absolute inset-0 bg-[--color-primary]/20 backdrop-blur-sm"></div>
                  )}
                </button>
              ))}
            </div>

            {/* Progress Indicators */}
            <div className="flex justify-center gap-2 mt-4">
              {screenshots.map((_, i) => (
                <div
                  key={i}
                  className={`h-1 rounded-full transition-all duration-300 ${
                    i === index ? "w-8 bg-[--color-primary]" : "w-4 bg-gray-300"
                  }`}
                />
              ))}
            </div>

            {/* Screenshot Counter */}
            <div className="text-center mt-4">
              <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                {index + 1} من {screenshots.length}
              </span>
            </div>
          </div>
        </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#3E4736] text-white py-12 lg:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-start md:items-center justify-between gap-8">
            {/* Logo & Description */}
            <div className="flex flex-col justify-center items-start md:items-center ">
              <div className="flex flex-col justify-center items-start md:items-center gap-4 mb-4">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-10 lg:h-12 brightness-0 invert"
                />
                <div className="flex flex-col justify-center items-center ">
                  <div className="text-white text-md lg:text-md font-bold">
                    منصتك الأولى لحجز خدمات المناسبات
                  </div>
                </div>
              </div>

              <p className="text-white max-w-md text-sm lg:text-sm leading-relaxed md:text-center">
                نجعل كل مناسبة تجربة استثنائية من خلال توفير أفضل الخدمات
                والمقدمين المعتمدين في المملكة العربية السعودية.
              </p>
            </div>

            {/* Links & Contact */}
            <div className="flex flex-col sm:flex-row gap-10 lg:gap-[10em] text-center">
              {/* Quick Links */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  روابط سريعة
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li>
                    <a href="/" className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200">
                      الرئيسية
                    </a>
                  </li>
                  <li>
                    <a href="/terms" className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200">
                      شروط وأحكام الاستخدام
                    </a>
                  </li>
                  <li>
                    <a href="/privacy" className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200">
                      سياسة الخصوصية
                    </a>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  تواصل معنا
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    info@adim-app.com
                  </li>
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    <a href="tel:+966557076035">0557076035</a>
                  </li>
                 
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    الرياض - المملكة العربية السعودية
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t-[.005em] border-white mt-[5em] pt-8 text-center">
            <p className="text-white text-sm lg:sm font-bold">
              © 2026 أديم المناسبات. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
